<info>
    <header>
        Nye priser fra april 2022
    </header>

    <content>
        <p class="header">Mindsteprisen stiger kun 1 kr.</p>
        <p>Priserne justeres for første gang i 8 år, og du kan her se de nye priser, der gælder fra april 2022. Fx stiger prisen kun 1 kr. på et 1/8-lod.</p>

        <div class="pricing-table">
            <span class="pricing-table-column-header">Lodtype</span>
            <span class="pricing-table-column-header">Topgevinst</span>
            <span class="pricing-table-column-header">Pris i dag</span>
            <span class="pricing-table-column-header">Pris pr. måned</span>
            <span class="pricing-table-column-header">Pris pr. halvår</span>
            
            <span class="item">Megalod</span>
            <span class="item">3.000.000 kr.</span>
            <span class="item">228 kr.</span>
            <span class="item">240 kr.</span>
            <span class="item">1.440 kr.</span>
            
            <span class="item even">1/1-lod</span>
            <span class="item even">2.000.000 kr.</span>
            <span class="item even">152 kr.</span>
            <span class="item even">160 kr.</span>
            <span class="item even">960 kr.</span>
            
            <span class="item">1/2-lod</span>
            <span class="item">1.000.000 kr.</span>
            <span class="item">76 kr.</span>
            <span class="item">80 kr.</span>
            <span class="item">480 kr.</span>
            
            <span class="item even">1/4-lod</span>
            <span class="item even">500.000 kr.</span>
            <span class="item even">38 kr.</span>
            <span class="item even">40 kr.</span>
            <span class="item even">240 kr.</span>
            
            <span class="item">1/8-lod</span>
            <span class="item">250.000 kr.</span>
            <span class="item">19 kr.</span>
            <span class="item">20 kr.</span>
            <span class="item">120 kr.</span>
        </div>
        <p></p>

        <p class="header">Flere penge i puljen - hele 80 millioner ekstra om året</p>
        <p>
            Fra april 2022 putter vi hele 80 millioner kroner ekstra i den årlige gevinstpulje, så den vil være på over 630.000.000 kr.
            Og hver måned vil der være over 22.000 gevinster - 3.500 flere end i dag! 
            Og der vil også være 1 ekstra milliongevinst - hver måned, året rundt, så der i alt vil være 132 million gevinster hvert år.
        </p>
    </content>
</info>
